import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { Space as AntSpace } from 'antd';
import styled from 'styled-components';
var Space = styled(AntSpace).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['justify', 'textAlign', 'block'].includes(prop);
  }
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: ", ";\n  justify-content: ", ";\n  text-align: ", ";\n"])), function (props) {
  return props.block && '100%';
}, function (props) {
  return props.justify;
}, function (props) {
  return props.textAlign;
});
Space.defaultProps = {
  justify: 'start',
  textAlign: 'left',
  block: true
};
export default Space;